import { Link, type RouteObject } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants/common';

export const channelsRoute: RouteObject = {
  path: ROUTE_PATHS.channels,
  lazy: async () => ({
    Component: (await import('@/pages/channels')).default,
  }),
  handle: {
    title: '数据渠道',
    crumb: () => '数据渠道',
  },
  children: [
    {
      path: ROUTE_PATHS.channelsAccount,
      lazy: async () => ({
        Component: (await import('@/pages/channels/ChannelsPage')).ChannelsPage,
      }),
      handle: {
        title: '渠道账户',
        crumb: () => <Link to={ROUTE_PATHS.channelsAccount}>渠道账户</Link>,
      },
    },
    {
      path: ROUTE_PATHS.channelsApplication,
      lazy: async () => ({
        Component: (await import('@/pages/channels/ChannelsPage')).ChannelsPage,
      }),
      handle: {
        title: '渠道应用',
        crumb: () => <Link to={ROUTE_PATHS.channelsApplication}>渠道应用</Link>,
      },
    },
  ]
};
